import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box from '@quintoandar/cozy-core/Box';
import Card from '@quintoandar/cozy-core/Card';
import Typography from '@quintoandar/cozy-core/Typography';
import VideoCamera from '@quintoandar/cozy-icons/VideoCamera';

import ChecklistTitleWrapper from 'containers/Checklist/ChecklistTitleWrapper';

import messages from './messages';

const items = {
  ratio: {
    label: messages.instructionHeaderCardDescriptionItemRatio,
    value: messages.instructionHeaderCardDescriptionItemRatioNumber,
  },
  width: {
    label: messages.instructionHeaderCardDescriptionItemWidth,
    value: messages.instructionHeaderCardDescriptionItemWidthNumber,
  },
  orientation: {
    label: messages.instructionHeaderCardDescriptionItemOrientation,
    value: messages.instructionHeaderCardDescriptionItemHorizontal,
  },
  video: {
    label: messages.instructionHeaderCardDescriptionItemVideo,
  },
};

export const InstructionHeader = () => (
  <>
    <ChecklistTitleWrapper>
      <Typography level="heading">
        <FormattedMessage {...messages.instructionHeaderTitle} />
      </Typography>
    </ChecklistTitleWrapper>
    <Box mt={3} mb={4}>
      <Typography kind="lighter">
        <FormattedMessage {...messages.instructionHeaderSubtitle} />
      </Typography>
    </Box>
    <Card>
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <VideoCamera fontSize="small" />
        <Box ml={1}>
          <Typography>
            <FormattedMessage {...messages.instructionHeaderCardTitle} />
          </Typography>
        </Box>
      </Box>
      <ul>
        {Object.entries(items).map(([key, item]) => {
          const label = <FormattedMessage {...item.label} />;
          const value = item.value && (
            <strong>
              <FormattedMessage {...item.value} />
            </strong>
          );

          return (
            <li key={key}>
              <Typography kind="lighter">
                {label} {value}
              </Typography>
            </li>
          );
        })}
      </ul>
    </Card>
  </>
);

export default InstructionHeader;
